import { c as _c } from "react/compiler-runtime";
import { IcoAsterix16, IcoChevronDown16, IcoChevronRight16 } from '@onefootprint/icons';
import { Tooltip } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TypeIcon from '../../../shared/type-icon';
import type { JSONSchema } from '../../schema-types';
type ViewPropertyItemProps = {
  name: string;
  schema: JSONSchema;
  isRequired: boolean;
};
const ViewPropertyItem = t0 => {
  const $ = _c(35);
  const {
    name,
    schema,
    isRequired
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "inputSchema.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const [isExpanded, setIsExpanded] = useState(false);
  let t2;
  if ($[1] !== schema.properties) {
    t2 = schema.properties && Object.keys(schema.properties).length > 0;
    $[1] = schema.properties;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hasNestedProperties = t2;
  let t3;
  if ($[3] !== isExpanded) {
    t3 = () => setIsExpanded(!isExpanded);
    $[3] = isExpanded;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !hasNestedProperties && !schema.description;
  let t5;
  if ($[5] !== hasNestedProperties || $[6] !== isExpanded) {
    t5 = hasNestedProperties && (isExpanded ? <IcoChevronDown16 /> : <IcoChevronRight16 />);
    $[5] = hasNestedProperties;
    $[6] = isExpanded;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== schema.type) {
    t6 = <div className="mt-1"><TypeIcon type={schema.type} /></div>;
    $[8] = schema.type;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isRequired || $[11] !== t) {
    t7 = isRequired && <Tooltip content={t(_temp)}><IcoAsterix16 /></Tooltip>;
    $[10] = isRequired;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = schema.format ? `(${schema.format})` : "";
  let t9;
  if ($[13] !== schema.type || $[14] !== t8) {
    t9 = <span className="px-2 py-1 rounded text-caption-2 bg-secondary">{schema.type} {t8}</span>;
    $[13] = schema.type;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== name || $[17] !== t7 || $[18] !== t9) {
    t10 = <span className="text-snippet-1 text-primary flex items-center gap-1">{name}{" "}{t7}{t9}</span>;
    $[16] = name;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== schema.description) {
    t11 = schema.description && <p className="text-body-2 text-quaternary">{capitalize(schema.description)}</p>;
    $[20] = schema.description;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="flex flex-col gap-1 items-start">{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6) {
    t13 = <div className="flex gap-3 items-start">{t6}{t12}</div>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t5) {
    t14 = <div className="flex justify-between items-center w-full"><div className="flex gap-3 items-center">{t5}{t13}</div></div>;
    $[28] = t13;
    $[29] = t5;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t3 || $[33] !== t4) {
    t15 = <div className="overflow-hidden"><button type="button" onClick={t3} className="flex flex-col gap-2 items-start w-full" disabled={t4}>{t14}</button></div>;
    $[31] = t14;
    $[32] = t3;
    $[33] = t4;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export default ViewPropertyItem;
function _temp($) {
  return $.required;
}